<template>
    <div class="category-edit__wrapper">
        <form @submit.prevent="onSubmit" @reset.prevent="onReset" class="app__card_edit">
            <div class="app__card-header">{{ categoryEditTitle }}</div>
            <div class="app__card-body_edit">
                <application-form-field
                    v-for="field in dataModelFields"
                    :key="field.name"
                    :field="field"
                    v-model="categoryData[field.name]"
                    dataModel="category"
                    :errors="formErrors[field.name]"
                    @change="clearFieldErrors(field)"
                ></application-form-field>
            </div>
            <div class="app__card-footer">
                <sah-button class="app__button_alt" type="reset">{{ $tc("words.cancel") }}</sah-button>
                <sah-button type="submit" :disabled="hasFormErrors">{{ $tc("words.save") }}</sah-button>
            </div>
        </form>
    </div>
</template>

<script>
import {store, SahButton} from "atom";
import ApplicationFormField from "./ApplicationFormField";
import FormValidationMixin from "../mixins/FormValidationMixin";
import {EDIT_OPERATION_STORE, EDIT_OPERATION_UPDATE} from "../constants";

const {createNamespacedHelpers} = store;
const {mapActions, mapState} = createNamespacedHelpers("arcman");

export default {
    name: "category-edit",
    props: {
        category: {type: Object, required: true},
        project: {type: Object, required: true},
        operation: {type: String, required: true},
    },
    components: {
        ApplicationFormField,
        SahButton,
    },
    mixins: [FormValidationMixin],
    computed: {
        dataModelFields() {
            return this.arcologyConstants.CATEGORY_FIELDS;
        },
        categoryEditTitle() {
            return this.isStoreOperation
                ? this.$tc("projects.newCategory")
                : `${this.$tc("words.edit")} ${this.category.name}`;
        },
        isStoreOperation() {
            return this.operation === EDIT_OPERATION_STORE;
        },
        isUpdateOperation() {
            return this.operation === EDIT_OPERATION_UPDATE;
        },
        ...mapState(["arcologyConstants"]),
    },
    methods: {
        ...mapActions({
            storeCategory: "CREATE_CATEGORY",
            updateCategory: "UPDATE_CATEGORY",
        }),
        onSubmit() {
            if (this.validateForm(this.dataModelFields, this.categoryData)) {
                if (this.isStoreOperation) {
                    this.storeCategory({project: this.project, category: this.categoryData});
                } else if (this.isUpdateOperation) {
                    this.updateCategory(this.project);
                }
                this.$emit("end");
            }
        },
        onReset() {
            this.$emit("cancel");
        },
    },
    data() {
        return {
            categoryData: JSON.parse(JSON.stringify(this.category)),
        };
    },
};
</script>

<style lang="scss" scoped>
.category-edit__wrapper::v-deep {
    @apply fixed top-0 left-0 z-10 h-full w-full flex flex-row items-center justify-center;
    background-color: $background-wrapper-edit-color;
}
</style>
